/* ==========================================================================
   LMM · REVIEWS.io — offizielle Widget-Mechanik (Weg A)
   --------------------------------------------------------------------------
   Lädt die REVIEWS.io-Widget-Scripts IDEMPOTENT (jedes höchstens einmal, auch
   wenn das „Core Snippet“-App-Embed ein Script bereits eingebunden hat) und
   initialisiert genau die Widgets, die auf der Seite vorhanden sind:

     · Rating Snippet         .ruk_rating_snippet   → ratingSnippet(...)
       Script: https://widget.reviews.co.uk/rating-snippet/dist.js
     · Product Reviews Widget  #ReviewsWidget       → new ReviewsWidget(...)
       Script: https://widget.reviews.co.uk/polaris/build.js
     · Company Badge          [data-lmm-badge-id]   → reviewsBadgeModern(...)
       Script: https://widget.reviews.io/badge-modern/dist.js
     · Shop-Gesamtbewertung   [data-lmm-ratingbar]  → eigene Anzeige, KEIN Fremd-Widget
       Datenpunkt: https://api.reviews.io/stats/all (~209 Byte statt ~168 KB Widget)
     · Reviews Carousel       [data-lmm-carousel]   → new carouselInlineWidget(...)
       Script: https://widget.reviews.io/carousel-inline-iframeless/dist.js

   Konfiguration: window.lmmReviews.store = öffentliche REVIEWS.io Store-ID
   (aus Theme-Setting „reviews_store_id“, KEIN Secret). Ohne Store-ID passiert
   nichts — der neutrale Platzhalter im Markup bleibt stehen.

   SICHERHEIT / EHRLICHKEIT: Es werden keine Sterne oder Zahlen erfunden. Ist
   kein Widget-Inhalt vorhanden, zeigt der Timeout-Fallback einen ehrlichen
   Leertext statt eines Dauer-Spinners.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__lmmReviewsInit) { return; }
  window.__lmmReviewsInit = true;

  var CFG = window.lmmReviews || {};
  var STORE = (CFG.store || '').toString().trim();
  if (!STORE) { return; } // ohne Store-ID nichts laden → Platzhalter bleibt

  var RATING_CLASS = 'ruk_rating_snippet';
  var SRC_RATING = 'https://widget.reviews.co.uk/rating-snippet/dist.js';
  var SRC_POLARIS = 'https://widget.reviews.co.uk/polaris/build.js';
  var SRC_BADGE = 'https://widget.reviews.io/badge-modern/dist.js';
  var SRC_STATS = 'https://api.reviews.io/stats/all?store=' + encodeURIComponent(STORE);
  var STATS_TIMEOUT = 6000; // ms bis der Datenpunkt aufgegeben wird
  var SRC_CAROUSEL = 'https://widget.reviews.io/carousel-inline-iframeless/dist.js';
  var CSS_CAROUSEL = 'https://assets.reviews.io/css/widgets/carousel-widget.css?_t=2024062402';
  var WIDGET_TIMEOUT = 9000; // ms bis Spinner-Ende (Produkt-Widget)
  var REVEAL_TIMEOUT = 12000; // ms: Slots (Sterne, dunkle Leiste) endgültig verstecken, wenn leer

  function ratingStarColor() {
    return window.getComputedStyle(document.documentElement)
      .getPropertyValue('--lmm-rating-star-color').trim() || '#b77900';
  }

  /* ---- idempotenter Script-Loader ---------------------------------------
     Merkt sich pro URL den Zustand und lädt eine bereits vorhandene Datei
     (z. B. vom Core-Snippet-App-Embed) NICHT erneut. */
  var loaded = {};
  function loadScript(src, cb) {
    if (loaded[src] === 'done') { if (cb) { cb(); } return; }
    if (loaded[src]) { if (cb) { loaded[src].push(cb); } return; }
    // Bereits im DOM? Dann nicht doppelt einhängen.
    if (document.querySelector('script[src="' + src + '"]')) {
      loaded[src] = 'done'; if (cb) { cb(); } return;
    }
    loaded[src] = cb ? [cb] : [];
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    function flush() {
      var q = loaded[src] || [];
      loaded[src] = 'done';
      for (var i = 0; i < q.length; i++) { if (q[i]) { q[i](); } }
    }
    s.onload = flush;
    s.onerror = flush; // nicht ewig blockieren; Timeout-Fallback greift
    document.head.appendChild(s);
  }

  /* Idempotenter Stylesheet-Loader (für Widgets, die ihre Layout-CSS NICHT selbst mitbringen,
     z. B. das „iframeless" Carousel — ohne diese CSS stapeln die Karten vertikal). */
  function loadStylesheet(href) {
    if (document.querySelector('link[rel="stylesheet"][href="' + href + '"]')) { return; }
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  /* Stellt sicher, dass eine globale REVIEWS.io-Funktion verfügbar ist –
     nutzt sie direkt, falls das Core-Snippet sie schon bereitgestellt hat. */
  function ensure(src, globalName, cb) {
    if (typeof window[globalName] === 'function') { cb(); return; }
    loadScript(src, function () { waitFor(globalName, cb, 0); });
  }
  function waitFor(globalName, cb, tries) {
    if (typeof window[globalName] === 'function') { cb(); return; }
    if (tries > 50) { return; } // ~5 s, dann aufgeben (Timeout-Fallback greift)
    setTimeout(function () { waitFor(globalName, cb, tries + 1); }, 100);
  }

  /* ---- Slot-Reveal: „sichtbar erst, wenn befüllt" --------------------------
     revealEl startet versteckt (CSS-Klasse lmm-rev-pending). Sobald contentEl echten
     REVIEWS.io-Inhalt hat (iframe/svg/img/Text/Kind), wird revealEl sichtbar. Kommt
     nach dem Timeout nichts, bleibt revealEl versteckt. So gibt es keine leere dunkle
     Leiste, keinen unsichtbaren Sterne-Link und keine leere reservierte Fläche —
     und keine erfundenen Sterne/Zahlen. */
  function slotHasContent(el) {
    if (el.querySelector('iframe, svg, img, canvas')) { return true; }
    if ((el.textContent || '').replace(/\s+/g, '').length > 0) { return true; }
    return el.children.length > 0;
  }
  function revealSlot(contentEl, revealEl, timeout, hasContent) {
    if (!contentEl || !revealEl) { return; }
    var test = hasContent || slotHasContent; // widget-spezifischer Content-Test optional
    var settled = false;
    var obs = null;
    function reveal() {
      if (settled) { return; }
      settled = true;
      if (obs) { obs.disconnect(); }
      revealEl.classList.remove('lmm-rev-pending');
      revealEl.classList.add('lmm-rev-ready');
    }
    function giveUp() {
      if (settled) { return; }
      settled = true;
      if (obs) { obs.disconnect(); }
      // revealEl bleibt versteckt (lmm-rev-pending) — kein unsichtbarer Link / kein leerer Balken
    }
    if (test(contentEl)) { reveal(); return; }
    if (window.MutationObserver) {
      obs = new MutationObserver(function () { if (test(contentEl)) { reveal(); } });
      obs.observe(contentEl, { childList: true, subtree: true });
    }
    setTimeout(giveUp, timeout || REVEAL_TIMEOUT);
  }

  /* ---- 1) Rating Snippet (PDP unter H1 + Produktkarten) -----------------
     ratingSnippet() scannt ALLE .ruk_rating_snippet-Elemente und liest deren data-sku.

     MEHRFACH AUFRUFBAR (Fix 2026-07-26): Kategorie- und Suchseiten tauschen die Produktliste
     per Section-Rendering aus (Sortieren, Filtern, Blättern, Zurück/Vor). Die neuen Karten
     bringen LEERE Sterne-Container mit — mit einem Einmal-Init blieben sie leer UND wegen
     lmm-rev-pending unsichtbar (genau das war der Bug: nach dem Sortierwechsel keine Sterne).
     Deshalb wird pro Container gemerkt, ob er schon behandelt wurde; nur wirklich neue
     Container bekommen einen Reveal-Watcher. Ein Wiederaufruf verdoppelt die Sterne nicht:
     ratingSnippet() SETZT den Slot-Inhalt (live verifiziert 2026-07-26 — exakt 5 Icons je
     Slot, auch nach mehrfachem Aufruf). */
  var INIT_ATTR = 'data-lmm-rev-init';
  var ratingTimer = null;
  function initRatingSnippet() {
    var fresh = document.querySelectorAll('.' + RATING_CLASS + ':not([' + INIT_ATTR + '])');
    if (!fresh.length) { return; }
    // Jeder Sterne-Slot bleibt versteckt, bis REVIEWS.io echte Sterne gerendert hat
    // → kein unsichtbarer Link, keine leere reservierte Fläche (PDP + Karten).
    for (var i = 0; i < fresh.length; i++) {
      fresh[i].setAttribute(INIT_ATTR, '1');
      var slot = fresh[i].closest('[data-lmm-rev-slot]');
      if (slot) { revealSlot(fresh[i], slot, REVEAL_TIMEOUT); }
    }
    // Mehrere Swaps kurz hintereinander (schnelles Klicken) → nur ein Render-Lauf.
    if (ratingTimer) { return; }
    ratingTimer = setTimeout(function () {
      ratingTimer = null;
      ensure(SRC_RATING, 'ratingSnippet', function () {
        try {
          window.ratingSnippet(RATING_CLASS, { store: STORE, usePolaris: true });
        } catch (e) { /* still */ }
      });
    }, 50);
  }

  /* ---- 2) Product Reviews Widget (unterer PDP-Bereich, vor Cross-Sell) ---
     polarisConfig(sku) ist die EINE Quelle für die Widget-Konfiguration: die PDP-Section
     und das Bewertungs-Popup (Abschnitt 6) rendern damit exakt dasselbe Widget mit
     denselben Daten — kein zweiter Datenstand, keine abweichende Optik. */
  function polarisConfig(sku) {
    /* Vollständiger Polaris-Options-Block (offizieller REVIEWS.io-Install-Code:
       Widget Library → Product Reviews Widget). OHNE dieses options-Objekt greift das
       Widget intern auf undefined-Felder zu und crasht (layout/lang).
       Angepasst: store zentral, SKU produktbezogen (product_review.sku), überall
       hide_if_no_results:true → bleibt leer, dann greift unser deutscher Timeout-Fallback
       statt eines englischen REVIEWS.io-Leertexts; KEIN structured_data (keine erfundenen
       Produktdaten, kein Schema-Konflikt); Sterne/Buttons in LMM-Rot.
       WICHTIG (Pre-Launch-Fix 2026-07-17): enable_rich_snippets:false im product_review-Block —
       Polaris injiziert sonst per Default ein ZWEITES Product-JSON-LD in den <head>
       (aggregateRating + review aus SHOP-Bewertungen, ohne offers) und kollidiert mit dem
       Theme-Product-LD aus lmm-pdp-main.liquid (Doppel-Entity, falsche Produkt-Sterne).
       Auf Kategorie-/Suchseiten wäre so ein injiziertes Product-LD sogar grob falsch —
       deshalb ist das Flag auch für das Popup zwingend. */
    return {
      store: STORE,
      widget: 'polaris',
      options: {
        types: 'product_review',
        lang: 'de',
        enable_sentiment_analysis: false,
        include_sentiment_preview: false,
        per_page: 8,
        store_review: { hide_if_no_results: true },
        third_party_review: { hide_if_no_results: true },
        product_review: {
          sku: sku,
          hide_if_no_results: true,
          enable_rich_snippets: false
        },
        questions: {
          hide_if_no_results: true,
          enable_ask_question: false,
          show_dates: false,
          include_qna_structured_data: false,
          grouping: sku
        },
        header: {
          enable_summary: true,
          enable_ratings: true,
          enable_attributes: true,
          enable_image_gallery: true,
          enable_percent_recommended: false,
          enable_write_review: true,
          enable_ask_question: false,
          overall_rating_style: 'outof5',
          image_thumbnail_size: 'large',
          rating_decimal_places: 2,
          enable_sub_header: true,
          use_write_review_button: false,
          enable_if_no_results: false,
          show_review_title_field: false
        },
        sentiment: {
          badge_text: 'Kundenstimmen',
          enable_rating_breakdown: false
        },
        filtering: {
          enable: true,
          enable_text_search: true,
          enable_overall_rating_filter: true,
          enable_language_filter: false,
          enable_language_filter_language_change: false,
          enable_ratings_filters: true,
          enable_attributes_filters: true,
          enable_expanded_filters: false,
          enable_sorting: true,
          enable_product_filter: false,
          enable_media_filter: true
        },
        reviews: {
          enable_share: true,
          enable_helpful_vote: true,
          enable_helpful_display: true,
          enable_report: true,
          enable_date: true,
          enable_images: true,
          enable_ratings: true,
          image_thumbnail_size: 'large',
          enable_attributes: true,
          enable_verified_badge: true,
          enable_subscriber_badge: true,
          enable_avatar: true,
          enable_reviewer_name: true,
          enable_product_name: true,
          enable_link_product: false,
          enable_reviewer_address: true,
          reviewer_address_format: 'country',
          enable_reviewer_recommends: true,
          enable_third_party_source: true,
          combine_title_stars: false,
          show_untranslated: false
        },
        avatars: {
          enable_gravatar: true,
          gravatar_fallback: 'identicon'
        }
      },
      styles: {
        '--common-star-color': ratingStarColor(),
        '--medium-star-size': '22px',
        '--small-star-size': '18px',
        '--primary-button-bg-color': '#d71013',
        '--primary-button-border-color': 'none',
        '--primary-button-text-color': '#ffffff',
        '--common-button-border-radius': '10px',
        '--common-button-text-transform': 'none'
      }
    };
  }

  /* ---- 2a) Aufbau des Produkt-Widgets — genau einmal -------------------- */
  var productDone = false;
  function mountProductWidget(el) {
    if (productDone) { return; }
    productDone = true;
    var sku = (el.getAttribute('data-sku') || '').trim();
    ensure(SRC_POLARIS, 'ReviewsWidget', function () {
      try {
        /* eslint-disable no-new */
        new window.ReviewsWidget('#' + el.id, polarisConfig(sku));
      } catch (e) { /* still */ }
    });
    startWidgetFallback(el);
  }

  /* ---- 2b) Polaris erst laden, wenn der Bewertungsbereich gebraucht wird ---
     Polaris (build.js + Chunks + elements-widget.css + Timeline-API) kostet im
     Initial-Load Bytes, Requests und Main-Thread — sichtbar wird davon zunächst
     nichts: der Bewertungsanker liegt auf einer PDP bei rund 2.700 px (mobil) bis
     9.600 px (Desktop), also mehrere Bildschirme unterhalb des ersten Viewports
     (gemessen 2026-07-27).

     Der Aufbau startet deshalb erst, wenn er wirklich gebraucht wird:
       a) der Bewertungsbereich nähert sich mit großzügigem Vorlauf dem Viewport,
       b) der Nutzer ist erkennbar auf dem Weg nach unten (Scroll-Schwelle) —
          das gibt dem Widget Vorlauf, bevor der Bereich sichtbar wird,
       c) eine direkte Aktion verlangt den Bereich sofort (Anker-Link aus der
          PDP-Chip-Navigation, Klick/Tastatur in der Bewertungskarte, Akkordeon),
       d) Direkteinstieg per #lmm-bewertungen (Deep-Link, Zurück-Navigation).

     UNVERÄNDERT sofort bleiben: Sterne-Snippet, Header-Rating-Bar, Company-Badge
     und vor allem das Karussell — dessen Ladepfad erzeugt den einzigen
     WebPage-JSON-LD-Block der Seite (Audit 2026-07-27).

     Das Bewertungs-Popup (Abschnitt 6) lädt Polaris wie bisher beim ersten Öffnen;
     beide Wege teilen sich über ensure()/loadScript() denselben Ladevorgang, ein
     zweiter Download entsteht nicht. */
  var ANKER_ID = 'lmm-bewertungen';
  var VORLAUF_VIEWPORTS = 2;   // rootMargin des IntersectionObserver
  var SCROLL_SCHWELLE = 1.5;   // Viewporthöhen, ab denen vorgeladen wird
  var productArmed = false;

  /* Hat dieses Produkt überhaupt eigene Bewertungen?
     Produkte OHNE Bewertungen dürfen NICHT verzögert aufgebaut werden: bei ihnen
     blendet startWidgetFallback() die ganze Karte aus, sobald feststeht, dass nichts
     kommt. Heute passiert das während des Seitenaufbaus, weit außerhalb des Blickfelds.
     Verzögert man den Aufbau, wandert genau dieses Ausblenden in den sichtbaren Bereich
     und verschiebt dort das Layout (gemessen 2026-07-27: CLS +0,128 beim Ankersprung
     auf einer PDP ohne Bewertungen, dazu mehrere Sekunden sichtbarer Ladezustand).
     Solche Seiten behalten deshalb exakt das bisherige Verhalten.

     Quelle ist das serverseitig gerenderte Product-JSON-LD der PDP (aggregateRating aus
     dem täglichen REVIEWS.io-Sync). Fehlt es, ist es unlesbar oder ändert sich das
     Markup, gilt „keine Bewertungen" → Sofort-Aufbau wie bisher. Der Patch kann dadurch
     konstruktionsbedingt nie Inhalte verstecken, die es ohne ihn gäbe. */
  function hatBewertungen() {
    var s = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < s.length; i++) {
      var j;
      try { j = JSON.parse(s[i].textContent); } catch (e) { continue; }
      var liste = Array.isArray(j) ? j : [j];
      for (var k = 0; k < liste.length; k++) {
        if (liste[k] && liste[k]['@type'] === 'Product' && liste[k].aggregateRating) {
          return true;
        }
      }
    }
    return false;
  }

  function initProductWidget() {
    if (productArmed) { return; }
    var el = document.querySelector('[data-lmm-review-widget]');
    if (!el || !el.id) { return; }
    productArmed = true;
    // Ohne IntersectionObserver oder ohne belegte Bewertungen: Aufbau wie bisher sofort.
    if (!window.IntersectionObserver || !hatBewertungen()) { mountProductWidget(el); return; }
    var karte = (el.closest && el.closest('[data-lmm-review-card]')) || el;

    var aufraeumen = [];
    function los() {
      for (var i = 0; i < aufraeumen.length; i++) {
        try { aufraeumen[i](); } catch (e) { /* still */ }
      }
      aufraeumen = [];
      mountProductWidget(el); // idempotent: productDone schützt vor Doppel-Init
    }

    // a) Annäherung an den Bewertungsbereich
    var io = new IntersectionObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        if (liste[i].isIntersecting) { los(); return; }
      }
    }, { rootMargin: Math.round(window.innerHeight * VORLAUF_VIEWPORTS) + 'px 0px' });
    io.observe(karte);
    aufraeumen.push(function () { io.disconnect(); });

    // b) Nutzer scrollt nennenswert nach unten
    function onScroll() {
      if ((window.pageYOffset || document.documentElement.scrollTop || 0)
          > window.innerHeight * SCROLL_SCHWELLE) { los(); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    aufraeumen.push(function () { window.removeEventListener('scroll', onScroll); });

    // c) Direkte Nutzeraktion: Klick/Tastatur/Fokus in der Karte oder Anker-Link
    function onAktion(e) {
      var t = e.target;
      if (!t || !t.closest) { return; }
      if (t.closest('[data-lmm-review-card]')) { los(); return; }
      var a = t.closest('a[href]');
      if (a && (a.getAttribute('href') || '').indexOf('#' + ANKER_ID) > -1) { los(); }
    }
    document.addEventListener('pointerdown', onAktion, true);
    document.addEventListener('keydown', onAktion, true);
    document.addEventListener('focusin', onAktion, true);
    aufraeumen.push(function () {
      document.removeEventListener('pointerdown', onAktion, true);
      document.removeEventListener('keydown', onAktion, true);
      document.removeEventListener('focusin', onAktion, true);
    });

    // d) Direkteinstieg per Hash
    if (window.location.hash === '#' + ANKER_ID) { los(); return; }
    function onHash() { if (window.location.hash === '#' + ANKER_ID) { los(); } }
    window.addEventListener('hashchange', onHash);
    aufraeumen.push(function () { window.removeEventListener('hashchange', onHash); });
  }

  /* Timeout-/Leer-Fallback: entfernt den Spinner, sobald REVIEWS.io den
     Container befüllt (MutationObserver) — oder nach WIDGET_TIMEOUT, dann mit
     ehrlichem Leertext. Keine erfundenen Bewertungen. */
  function isFilled(el) {
    // REVIEWS.io hat echten Inhalt gerendert, wenn der Mount messbare Höhe hat.
    // Ein leerer Polaris-Wrapper bleibt flach; der Lade-Spinner ist absolut
    // positioniert (im .lmm-rev-widget-Wrapper) und zählt NICHT zur Mount-Höhe.
    // So greift der Fallback auch, wenn Polaris nur einen leeren Container einhängt.
    return el.offsetHeight > 48;
  }
  /* Kopf-Zusammenfassung (Chris 26.07.2026): „Kundenbewertungen 5.00 ***** (19)" soll die
     Überschrift des mobilen Aufklapp-Blocks sein — und es soll NUR EINE Sterne-Anzeige geben.
     Deshalb wird die Rating-Zeile aus dem Widget-Kopf geklont (echte REVIEWS.io-Werte, rote
     Widget-Sterne) und die Original-Gruppe im Widget per CSS ausgeblendet. Erst wenn der Klon
     wirklich sitzt, bekommt die Karte `lmm-rev-has-headsum` — schlägt das Klonen fehl (fremdes
     Markup geändert), bleibt der Widget-Kopf unangetastet sichtbar. Nichts wird erfunden. */
  function mountHeadSummary(el, versuch) {
    var card = el.closest('[data-lmm-review-card]');
    if (!card) { return; }
    var slot = card.querySelector('[data-lmm-rev-headsum]');
    if (!slot) { return; }
    var left = el.querySelector('.ElementsWidget__header .header__group--left');
    if (!left) { return; }
    // 1) Rating-Zeile (Wert + Sterne) klonen — idempotent.
    if (slot.getAttribute('data-lmm-stars') !== '1') {
      var ratingRow = left.firstElementChild;
      if (ratingRow && ratingRow.querySelector('[class*="RatingStars"]')) {
        slot.appendChild(ratingRow.cloneNode(true));
        slot.setAttribute('data-lmm-stars', '1');
      }
    }
    // Sitzt der Klon, wird im Widget NUR die geklonte Rating-Zeile ausgeblendet (CSS) —
    // „Basierend auf N Bewertungen" bleibt dort stehen, damit die Zahl nicht verlorengeht
    // und die Kopfzeile auf schmalen Handys einzeilig bleibt.
    if (slot.getAttribute('data-lmm-stars') === '1') {
      card.classList.add('lmm-rev-has-headsum');
      return;
    }
    // Widget rendert den Kopf in Etappen → kurz später erneut versuchen.
    var n = versuch || 0;
    if (n < 4) { setTimeout(function () { mountHeadSummary(el, n + 1); }, 800); }
  }

  function startWidgetFallback(el) {
    var settled = false;
    var obs = null;
    function settle() {
      if (settled) { return; }
      settled = true;
      if (obs) { obs.disconnect(); }
      // Lade-Spinner entfernen. KEIN „Noch keine Bewertungen vorhanden."-Text mehr.
      var loading = el.querySelector('.lmm-rev-loading');
      if (loading && loading.parentNode) { loading.parentNode.removeChild(loading); }
      if (isFilled(el)) { mountHeadSummary(el); }
      // Hat das Produkt (noch) keine eigene Bewertung, die gesamte Produkt-Bewertungs-Karte
      // ausblenden — der shop-weite Karussell-Abschnitt darunter liefert den Social Proof.
      // Kein leerer Kasten, kein Geister-Heading, kein Schreiben-Button ins Leere.
      if (!isFilled(el)) {
        var card = el.closest('[data-lmm-review-card]');
        if (card) { card.style.display = 'none'; }
      }
    }
    if (isFilled(el)) { settle(); return; }
    if (window.MutationObserver) {
      obs = new MutationObserver(function () { if (isFilled(el)) { settle(); } });
      obs.observe(el, { childList: true, subtree: true });
    }
    setTimeout(settle, WIDGET_TIMEOUT);
  }

  /* ---- 3) Company Badge (Header-Trustbar / Footer) ----------------------- */
  var badgeDone = false;
  function initBadges() {
    if (badgeDone) { return; }
    var badges = document.querySelectorAll('[data-lmm-badge-id]');
    if (!badges.length) { return; }
    badgeDone = true;
    ensure(SRC_BADGE, 'reviewsBadgeModern', function () {
      for (var i = 0; i < badges.length; i++) {
        var b = badges[i];
        if (!b.id) { continue; }
        try {
          window.reviewsBadgeModern(b.id, {
            store: STORE,
            translateReviews: ' Bewertungen',
            translateAverage: ' Durchschnitt',
            translateDecimal: ','
          });
        } catch (e) { /* still */ }
      }
    });
  }

  /* ---- 4) Shop-Gesamtbewertung in der dunklen Header-Leiste ----------------
     Bis 27.07.2026 lud diese Stelle das REVIEWS.io-„Rating Bar Widget"
     (modern-widgets/rating-bar.js). Gemessen: ~133 KB übertragen, ~434 KB entpackt,
     dazu Widget-CSS, Icon-Font, Logo und vier API-Aufrufe — zusammen ~168 KB und
     12 Requests auf JEDEM Seitentyp. Geliefert hat es eine reine Anzeigezeile: kein
     Link, kein Button, kein Popup, nicht fokussierbar, Klick ohne Wirkung.

     Jetzt: EIN Datenpunkt (api.reviews.io/stats/all, ~209 Byte) füllt das eigene
     Markup aus snippets/lmm-company-review-badge.liquid. Sterne, Zahlen und der
     zugängliche Name entstehen ausschließlich aus dieser Antwort — nichts ist
     hartcodiert, nichts wird geschätzt. Kommt keine oder eine unvollständige Antwort,
     bleibt die Zeile leer und lmm-header.css blendet mobil die USP-Zeile ein, damit
     weder ein leerer schwarzer Balken noch ein Nachrutschen entsteht. */
  var ratingBarDone = false;

  /* Genau EIN stats/all-Request pro Dokument: parallele Anforderer hängen sich an den
     laufenden an (gleiche Mechanik wie loadScript). Kein localStorage, kein eigener
     Cache über die Seitenlebensdauer hinaus — die HTTP-Antwort ist bereits
     „public, max-age=7200", das Caching übernimmt der Browser. */
  var statsZustand = null; // null | 'laeuft' | 'fertig' | 'fehler'
  var statsDaten = null;
  var statsWarteschlange = [];
  function holeStats(cb) {
    if (statsZustand === 'fertig') { cb(statsDaten); return; }
    if (statsZustand === 'fehler') { cb(null); return; }
    statsWarteschlange.push(cb);
    if (statsZustand === 'laeuft') { return; }
    statsZustand = 'laeuft';
    var erledigt = false;
    function abschluss(daten) {
      if (erledigt) { return; }
      erledigt = true;
      statsDaten = daten;
      statsZustand = daten ? 'fertig' : 'fehler';
      var q = statsWarteschlange;
      statsWarteschlange = [];
      for (var i = 0; i < q.length; i++) { q[i](daten); }
    }
    var xhr;
    try { xhr = new XMLHttpRequest(); } catch (e) { abschluss(null); return; }
    xhr.open('GET', SRC_STATS, true);
    xhr.timeout = STATS_TIMEOUT;
    xhr.onload = function () {
      if (xhr.status < 200 || xhr.status >= 300) { abschluss(null); return; }
      var j = null;
      try { j = JSON.parse(xhr.responseText); } catch (e) { j = null; }
      abschluss(j);
    };
    xhr.onerror = function () { abschluss(null); };
    xhr.ontimeout = function () { abschluss(null); };
    xhr.onabort = function () { abschluss(null); };
    try { xhr.send(); } catch (e) { abschluss(null); }
  }

  /* Gesamtwert genau wie in der bisherigen Anzeige: alle Bewertungsgruppen mit
     mindestens einer Bewertung werden nach Anzahl gewichtet zusammengefasst
     (Produkt- + Shopbewertungen; die dritte Gruppe ist derzeit leer). Fehlt eine
     Gruppe oder ist ein Feld unbrauchbar, wird sie übersprungen; bleibt am Ende
     keine Bewertung übrig, gibt es KEINE Anzeige statt einer geratenen Zahl. */
  function rechneGesamtbewertung(j) {
    if (!j || typeof j !== 'object') { return null; }
    var gruppen = ['product_review_stats', 'company_review_stats', 'third_party_review_stats'];
    var gewichtet = 0;
    var anzahl = 0;
    for (var i = 0; i < gruppen.length; i++) {
      var g = j[gruppen[i]];
      if (!g || typeof g !== 'object') { continue; }
      var n = parseInt(g.total_reviews, 10);
      var s = parseFloat(g.average_rating);
      if (!isFinite(n) || n <= 0 || !isFinite(s) || s <= 0 || s > 5) { continue; }
      anzahl += n;
      gewichtet += s * n;
    }
    if (anzahl <= 0) { return null; }
    var schnitt = gewichtet / anzahl;
    if (!isFinite(schnitt) || schnitt <= 0 || schnitt > 5) { return null; }
    return { schnitt: schnitt, anzahl: anzahl };
  }

  /* Deutsche Formatierung: Tausenderpunkt, Dezimalkomma, genau eine Nachkommastelle. */
  function deZahl(n) {
    try { return new Intl.NumberFormat('de-DE').format(n); }
    catch (e) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  }
  function deWert(x) {
    try {
      return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1,
        maximumFractionDigits: 1 }).format(x);
    } catch (e) { return (Math.round(x * 10) / 10).toFixed(1).replace('.', ','); }
  }

  function initRatingBar() {
    if (ratingBarDone) { return; }
    var wrap = document.querySelector('[data-lmm-ratingbar]');
    if (!wrap) { return; }
    var el = wrap.querySelector('[data-lmm-hdrrating]');
    if (!el) { return; }
    ratingBarDone = true;
    var fuellung = el.querySelector('.lmm-hdrrating__fill');
    var wertEl = el.querySelector('[data-lmm-hdrrating-wert]');
    var anzahlEl = el.querySelector('[data-lmm-hdrrating-anzahl]');
    holeStats(function (daten) {
      var wert = rechneGesamtbewertung(daten);
      if (!wert || !fuellung || !wertEl || !anzahlEl) {
        // Keine belegten Zahlen: nichts anzeigen, nichts erfinden. Die reservierte Höhe
        // bleibt stehen; mobil rückt per CSS die USP-Zeile an diese Stelle.
        var kopf = el.closest ? el.closest('.lmm-site-header') : null;
        if (kopf) { kopf.classList.add('lmmh-rating-unavailable'); }
        return;
      }
      var w = deWert(wert.schnitt);
      var n = deZahl(wert.anzahl);
      fuellung.style.width = (Math.max(0, Math.min(5, wert.schnitt)) / 5 * 100).toFixed(2) + '%';
      // Nur die beiden Zahlen werden gesetzt — der Satz steht schon im Markup und hat
      // damit von der ersten Darstellung an seine endgültige Breite.
      wertEl.textContent = w;
      anzahlEl.textContent = n;
      // Genau EIN sinnvoller Vorlesetext für die ganze Zeile; Sterne und sichtbarer
      // Text bleiben über aria-hidden bzw. role="img" aus dem Baum → keine Dopplung.
      el.setAttribute('aria-label', 'Shop-Bewertung: ' + w + ' von 5, basierend auf '
        + n + ' Bewertungen');
      el.removeAttribute('aria-hidden');
      el.classList.add('is-ready');
      // Falls das Modern-Header-JS die dunkle Leiste (noch) nicht umgebaut hat, wird sie
      // hier wie bisher freigeschaltet — sonst bliebe sie per .lmm-rev-pending verborgen.
      var topbar = wrap.closest('.lmmh-topbar');
      if (topbar) { topbar.classList.remove('lmm-rev-pending'); topbar.classList.add('lmm-rev-ready'); }
    });
  }

  /* ---- 5) Reviews Carousel (Startseite / Kategorie / PDP) -----------------
     Allgemeine Shop-Bewertungen als scrollbares Karussell (company + product) —
     dieselbe Mechanik/Config wie im alten Shop (leuchtmittelmarkt.com). „iframeless":
     REVIEWS.io injiziert echtes DOM in den Container, erbt also unsere Seiten-Schrift.
     Der Slot startet visibility:hidden (NICHT display:none — sonst misst das Karussell
     0 Breite), Reveal, sobald echte Bewertungen gerendert sind. */
  var carouselDone = false;
  function carouselFilled(el) {
    return !!el.querySelector('.CarouselWidget, .R-ReviewsList, .CarouselWidget-prefix, img');
  }
  function initCarousel() {
    if (carouselDone) { return; }
    var el = document.querySelector('[data-lmm-carousel]');
    if (!el || !el.id) { return; }
    carouselDone = true;
    // Layout-CSS des Carousels laden (das iframeless-Widget bringt sie NICHT selbst mit).
    loadStylesheet(CSS_CAROUSEL);
    var slot = el.closest('[data-lmm-carousel-slot]');
    if (slot) { revealSlot(el, slot, REVEAL_TIMEOUT, carouselFilled); }
    ensure(SRC_CAROUSEL, 'carouselInlineWidget', function () {
      try {
        /* Konfiguration übernommen vom alten Shop (erprobt) — Sterne/Scroll-Pfeile in
           LMM-Rot, Text in LMM-Ink; sonst REVIEWS.io-Defaults. */
        /* eslint-disable no-new */
        new window.carouselInlineWidget(el.id, {
          store: STORE,
          sku: '',
          lang: 'de',
          carousel_type: 'default',
          styles_carousel: 'CarouselWidget--sideHeader',
          options: {
            general: {
              review_type: 'company, product',
              min_reviews: '1',
              max_reviews: '20',
              address_format: 'CITY, COUNTRY',
              enable_auto_scroll: 10000
            },
            header: {
              enable_overall_stars: true,
              rating_decimal_places: 2
            },
            reviews: {
              enable_customer_name: true,
              enable_customer_location: true,
              enable_verified_badge: true,
              enable_subscriber_badge: true,
              enable_recommends_badge: true,
              enable_photos: true,
              enable_videos: true,
              enable_review_date: true,
              disable_same_customer: true,
              min_review_percent: 4,
              third_party_source: true,
              hide_empty_reviews: true,
              enable_product_name: true,
              tags: '',
              branch: '',
              enable_branch_name: false
            },
            popups: {
              enable_review_popups: true,
              enable_helpful_buttons: true,
              enable_helpful_count: true,
              enable_share_buttons: true
            }
          },
          translations: {
            verified_customer: 'Verifizierter Kauf',
            rating: 'Sterne'
          },
          styles: {
            '--base-font-size': '16px',
            '--base-maxwidth': '100%',
            '--reviewsio-logo-style': 'var(--logo-normal)',
            '--common-star-color': ratingStarColor(),
            '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
            '--medium-star-size': '22px',
            '--small-star-size': '19px',
            '--header-width': '160px',
            '--item-maximum-columns': '5',
            '--heading-text-color': '#1d1f24',
            '--heading-text-font-weight': '600',
            '--body-text-color': '#1d1f24',
            '--author-font-weight': '600',
            '--scroll-button-icon-color': '#d71013'
          }
        });
      } catch (e) { /* still */ }
    });
  }

  /* ---- 6) Bewertungs-Popup (Sterne auf Produktkarten + PDP) ---------------
     Chris 26.07.2026: „Auf die Sterne klicken → Fenster mit den Bewertungen."
     Ein Klick auf eine Sterne-Zeile öffnet einen Dialog mit GENAU demselben
     REVIEWS.io-Produkt-Widget wie auf der PDP (polarisConfig) — gleiche Daten,
     gleiche Optik, kein zweiter Datenstand und nichts Erfundenes.

     Progressive Enhancement: Der Trigger ist ein echter Link auf den Bewertungs-
     bereich der Produktseite. Ohne JS (oder wenn REVIEWS.io nicht lädt) führt er
     dorthin; mit JS öffnet er das Popup. Strg/Cmd/Mittelklick bleiben „in neuem
     Tab öffnen".

     Performance: Das Polaris-Script wird erst beim ERSTEN Öffnen geladen —
     Kategorie- und Suchseiten laden im Initial-Load unverändert wenig. */
  var pop = null;             // Dialog-Wrapper (einmal pro Seite, lazy)
  var popMount = null;        // Container, in den das Widget gerendert wird
  var popTitleEl = null;
  var popLinkEl = null;
  var popNoteEl = null;
  var popLoadEl = null;
  var popSku = '';            // zuletzt gerenderte SKU (Cache: gleiche SKU → kein Neu-Rendern)
  var popSeq = 0;
  var popTrigger = null;      // Element, das den Dialog geöffnet hat (Fokus-Rückgabe)
  var popTimer = null;

  function buildPopup() {
    if (pop) { return; }
    pop = document.createElement('div');
    pop.className = 'lmm-revpop lmm-rev';
    pop.setAttribute('hidden', '');
    pop.innerHTML =
      '<div class="lmm-revpop__backdrop" data-lmm-revpop-close></div>' +
      '<div class="lmm-revpop__dialog" role="dialog" aria-modal="true" aria-labelledby="lmm-revpop-title">' +
        '<div class="lmm-revpop__head">' +
          '<div class="lmm-revpop__heading">' +
            '<p class="lmm-revpop__kicker">Kundenbewertungen</p>' +
            '<p class="lmm-revpop__title" id="lmm-revpop-title"></p>' +
          '</div>' +
          '<button type="button" class="lmm-revpop__x" data-lmm-revpop-close data-lmm-revpop-x aria-label="Bewertungen schließen">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="lmm-revpop__body">' +
          '<div class="lmm-revpop__loading" data-lmm-revpop-loading><span class="lmm-rev-spin"></span>Bewertungen werden geladen …</div>' +
          '<p class="lmm-revpop__note" data-lmm-revpop-note hidden>Für diesen Artikel liegen aktuell keine einzelnen Bewertungen vor.</p>' +
          '<div class="lmm-revpop__mount" data-lmm-revpop-mount></div>' +
        '</div>' +
        '<div class="lmm-revpop__foot">' +
          '<a class="lmm-revpop__link" data-lmm-revpop-link href="#" hidden>Zum Produkt</a>' +
          '<button type="button" class="lmm-revpop__close" data-lmm-revpop-close>Schließen</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(pop);
    popMount = pop.querySelector('[data-lmm-revpop-mount]');
    popTitleEl = pop.querySelector('#lmm-revpop-title');
    popLinkEl = pop.querySelector('[data-lmm-revpop-link]');
    popNoteEl = pop.querySelector('[data-lmm-revpop-note]');
    popLoadEl = pop.querySelector('[data-lmm-revpop-loading]');
    pop.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-lmm-revpop-close]')) { closePopup(); }
    });
  }

  function lockScroll(on) {
    var d = document.documentElement;
    if (on) {
      var sb = window.innerWidth - d.clientWidth; // Scrollbar-Breite kompensieren → kein Layout-Sprung
      if (sb > 0) { d.style.setProperty('--lmm-revpop-sb', sb + 'px'); }
      d.classList.add('lmm-revpop-lock');
    } else {
      d.classList.remove('lmm-revpop-lock');
      d.style.removeProperty('--lmm-revpop-sb');
    }
  }

  function onPopKey(e) {
    if (!pop || pop.hasAttribute('hidden')) { return; }
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closePopup(); return; }
    if (e.key !== 'Tab') { return; }
    // Fokus bleibt im Dialog (auch für die Buttons, die REVIEWS.io selbst rendert).
    var all = pop.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
    var list = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetWidth || all[i].offsetHeight || all[i].getClientRects().length) { list.push(all[i]); }
    }
    if (!list.length) { return; }
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function setPopState(loading, empty) {
    if (popLoadEl) { popLoadEl.hidden = !loading; }
    if (popNoteEl) { popNoteEl.hidden = !empty; }
  }

  function watchPopupFill(host) {
    var settled = false;
    var obs = null;
    if (popTimer) { clearTimeout(popTimer); popTimer = null; }
    function done() {
      if (settled) { return; }
      settled = true;
      if (obs) { obs.disconnect(); }
      if (popTimer) { clearTimeout(popTimer); popTimer = null; }
      // Ehrlicher Leerzustand statt Dauer-Spinner — es werden keine Bewertungen erfunden.
      setPopState(false, !isFilled(host));
    }
    if (isFilled(host)) { done(); return; }
    if (window.MutationObserver) {
      obs = new MutationObserver(function () { if (isFilled(host)) { done(); } });
      obs.observe(host, { childList: true, subtree: true });
    }
    popTimer = setTimeout(done, WIDGET_TIMEOUT);
  }

  /* Kein Produkt-Rich-Snippet aus dem Popup (verifiziert 26.07.2026): Polaris hängt trotz
     `enable_rich_snippets:false` ein <script id="reviewsWidgetProductSnippets"> mit
     Product+aggregateRating in den <head>, sobald das Widget außerhalb einer Produktseite
     rendert. Auf einer Kategorie-/Suchseite wäre das ein falsches Auszeichnungsobjekt (ein
     Produkt-Schema für eine Listenseite), auf der PDP eine zweite Product-Entity neben dem
     Theme-Schema. Deshalb: nur das vom Popup NEU eingefügte Element entfernen — war beim
     Öffnen schon eins da (z. B. von einer App), bleibt es unangetastet. */
  var ldGuardOn = false;
  function guardRichSnippets() {
    if (ldGuardOn) { return; }
    ldGuardOn = true;
    if (document.getElementById('reviewsWidgetProductSnippets')) { return; } // fremd → nicht anfassen
    var kill = function () {
      var el = document.getElementById('reviewsWidgetProductSnippets');
      if (el && el.parentNode) { el.parentNode.removeChild(el); }
    };
    kill();
    if (window.MutationObserver && document.head) {
      new MutationObserver(kill).observe(document.head, { childList: true });
    }
  }

  /* Produktbewertungssterne im Popup in Gold.
     Polaris malt seine Sterne NICHT über `color`, sondern als background-Gradient
     (der Füllstand steckt im Farbstopp) — CSS-Farbregeln sind dort wirkungslos, das
     zeigt nur ein Screenshot, keine DOM-Messung. Den Farbwert legt Polaris beim ERSTEN
     Init der Seite fest: auf Kategorie-/Suchseiten ist das der Rating-Snippet-Init mit
     REVIEWS.io-Grün, unser styles-Block im Popup kommt zu spät. Deshalb tauschen wir
     nur den grünen Stopp gegen den zentralen Goldton; Füllstände und das Grau leerer Sterne
     bleiben exakt erhalten (keine geschönte Darstellung). */
  var REV_GREEN = /rgb\(103,\s*193,\s*22\)/g;
  function recolorStars(root) {
    var icons = root.querySelectorAll('[class*="stars__icon"]');
    for (var i = 0; i < icons.length; i++) {
      var bg = window.getComputedStyle(icons[i]).backgroundImage;
      if (bg && bg.indexOf('103, 193, 22') > -1) {
        icons[i].style.backgroundImage = bg.replace(REV_GREEN, ratingStarColor());
      }
    }
  }
  function watchPopupStars(host) {
    recolorStars(host);
    if (!window.MutationObserver) { return; }
    var t = null;
    // Sortieren/Filtern/Blättern im Widget rendert neue Sterne nach → gedrosselt nachfärben.
    new MutationObserver(function () {
      if (t) { return; }
      t = setTimeout(function () { t = null; recolorStars(host); }, 120);
    }).observe(host, { childList: true, subtree: true });
  }

  function renderPopupWidget(sku) {
    if (popSku === sku && popMount.firstChild) { return; } // schon gerendert → wiederverwenden
    guardRichSnippets();
    popSku = sku;
    popMount.innerHTML = '';
    setPopState(true, false);
    var host = document.createElement('div');
    host.id = 'lmm-revpop-widget-' + (++popSeq); // eigene ID je SKU: kein Konflikt mit #ReviewsWidget der PDP
    host.className = 'lmm-revpop__widget';
    popMount.appendChild(host);
    ensure(SRC_POLARIS, 'ReviewsWidget', function () {
      try {
        /* eslint-disable no-new */
        new window.ReviewsWidget('#' + host.id, polarisConfig(sku));
      } catch (e) { /* still */ }
    });
    watchPopupFill(host);
    watchPopupStars(host);
  }

  function openPopup(trigger) {
    var sku = (trigger.getAttribute('data-lmm-rev-sku') || '').trim();
    if (!sku) { return false; }
    buildPopup();
    popTrigger = trigger;
    var title = (trigger.getAttribute('data-lmm-rev-title') || '').trim();
    popTitleEl.textContent = title; // textContent, nicht innerHTML
    popTitleEl.hidden = !title;
    var href = trigger.getAttribute('href') || '';
    if (href && href.charAt(0) !== '#') { popLinkEl.href = href; popLinkEl.hidden = false; }
    else { popLinkEl.hidden = true; }
    pop.removeAttribute('hidden');
    lockScroll(true);
    document.addEventListener('keydown', onPopKey, true);
    var x = pop.querySelector('[data-lmm-revpop-x]');
    if (x) { x.focus(); }
    // Erst rendern, wenn der Dialog wirklich sichtbar ist — Polaris misst sonst 0 Breite.
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        pop.classList.add('is-open');
        renderPopupWidget(sku);
      });
    } else {
      pop.classList.add('is-open');
      renderPopupWidget(sku);
    }
    return true;
  }

  function closePopup() {
    if (!pop || pop.hasAttribute('hidden')) { return; }
    pop.classList.remove('is-open');
    pop.setAttribute('hidden', '');
    lockScroll(false);
    document.removeEventListener('keydown', onPopKey, true);
    if (popTrigger && document.contains(popTrigger) && popTrigger.focus) { popTrigger.focus(); }
    popTrigger = null;
  }

  var popupDone = false;
  function initReviewPopup() {
    if (popupDone) { return; }
    popupDone = true;
    // Delegiert am document: gilt auch für Karten, die per Filter/PJAX neu gerendert werden.
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
      var t = e.target && e.target.closest ? e.target.closest('[data-lmm-rev-open]') : null;
      if (!t) { return; }
      if (openPopup(t)) { e.preventDefault(); }
    });
  }

  function initAll() {
    initRatingSnippet();
    initProductWidget();
    initBadges();
    initRatingBar();
    initCarousel();
    initReviewPopup();
    /* Kategorie-/Suchliste wurde per PJAX getauscht (lmm-collection.js) → die frisch
       gerenderten Karten haben leere Sterne-Container, die nachgezogen werden müssen.
       Delegiert am document, damit kein Modul das andere kennen muss. */
    document.addEventListener('lmm:content-swapped', function () { initRatingSnippet(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
